// extracted by mini-css-extract-plugin
module.exports = {"small":"Paragraph_small__3jHTS","regular":"Paragraph_regular__2p-tX","big":"Paragraph_big__1P_bp"};